import { default as _91_46_46_46route_93tmK3OOVYZaMeta } from "/builds/webcontact/marxzell/pages/[...route].vue?macro=true";
import { default as exampleyX7o59dG8EMeta } from "/builds/webcontact/marxzell/pages/example.vue?macro=true";
import { default as indextlo56cpQ9mMeta } from "/builds/webcontact/marxzell/pages/index.vue?macro=true";
export default [
  {
    name: "route",
    path: "/:route(.*)*",
    component: () => import("/builds/webcontact/marxzell/pages/[...route].vue")
  },
  {
    name: "example",
    path: "/example",
    component: () => import("/builds/webcontact/marxzell/pages/example.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/webcontact/marxzell/pages/index.vue")
  }
]